
import CrudMultiSelect from '@gid/vue-common/components/filters/CrudMultiSelect.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    CrudMultiSelect,
  },
})
export default class JobSelector extends Vue {
  @Prop({ default: null }) value!: any;

  get locale(): string {
    return this.$store.getters.locale;
  }

  get transformValue() {
    const locale = this.locale;
    return ({
      jobStatus,
      jobStatusDescriptionLangs,
    }: {
      jobStatus: string;
      jobStatusDescriptionLangs: Array<{ locale: string; nameGid: string }>;
    }) => {
      const byLocale = jobStatusDescriptionLangs?.find(
        (lang) => lang.locale === locale,
      );
      return {
        value: jobStatus,
        label:
          byLocale?.nameGid ??
          jobStatusDescriptionLangs?.[0]?.nameGid ??
          jobStatus,
      };
    };
  }
}
